"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_Possessed_OnKilledEventHandlerScript = void 0;
const __1 = require("../..");
const ActorArgs_1 = require("../../core/actors/ActorArgs");
const ActorType_1 = require("../../core/actors/ActorType");
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
let Effect_Possessed_OnKilledEventHandlerScript = class Effect_Possessed_OnKilledEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.Killed) {
            return;
        }
        const effectCreator = container.getActor(handler.args.scriptArgs.effectCreatorId);
        if (effectCreator.companionIds.length >= 2) {
            return;
        }
        const invoker = container.getActor(handler.args.scriptArgs.effectCreatorId);
        const soulActorArgs = new ActorArgs_1.NpcActorArgs(effectCreator.faction, ActorType_1.ActorType.AugurSoul, effectCreator.level, 
        // attributes...
        Object.entries(invoker.maxAttributeValues).reduce((pet, [key, value]) => {
            let multiplier = .5;
            switch (+key) {
                case __1.AttributeType.Health:
                    multiplier = .75;
                    break;
            }
            pet[key] = Math.round(value * multiplier);
            return pet;
        }, {}), {
            [__1.AbilitySlot.Ability1]: Registries_1.ActorAbilities.getItem("Abracadabra").mk()
        })
            .withAi("BasicV2", {
            abilityPriorities: [
                {
                    slot: __1.AbilitySlot.Ability1,
                    target: "random"
                }
            ]
        });
        container.summonCompanion(sequence, effectCreator.id, soulActorArgs);
        const [consumeSoulsSlot] = container.getEquippedAbility(effectCreator.id, "ConsumeSouls");
        container.enableAbility(sequence, effectCreator.id, consumeSoulsSlot);
    }
};
Effect_Possessed_OnKilledEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_Possessed_OnKilled")
], Effect_Possessed_OnKilledEventHandlerScript);
exports.Effect_Possessed_OnKilledEventHandlerScript = Effect_Possessed_OnKilledEventHandlerScript;
